module.exports = __webpack_public_path__ + "img/warning.264f0cd4.svg";